var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0DB4F;}\r\n\t.st1{fill:#323330;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,0h25.5C43,0,48,5,48,11.2v25.5C48,43,43,48,36.8,48H11.2C5,48,0,43,0,36.8V11.2C0,5,5,0,11.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.6,40.1l3.7-2.2c0.7,1.3,1.4,2.3,2.9,2.3c1.5,0,2.4-0.6,2.4-2.8V22h4.5v15.4c0,4.7-2.7,6.8-6.7,6.8 C15.8,44.2,13.7,42.4,12.6,40.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,39.6l3.7-2.1c1,1.6,2.2,2.7,4.4,2.7c1.9,0,3.1-0.9,3.1-2.2c0-1.5-1.2-2.1-3.3-3l-1.1-0.5 c-3.3-1.4-5.4-3.1-5.4-6.8c0-3.4,2.6-6,6.6-6c2.9,0,4.9,1,6.4,3.6l-3.5,2.3c-0.8-1.4-1.6-1.9-2.9-1.9c-1.3,0-2.2,0.8-2.2,1.9 c0,1.4,0.8,1.9,2.8,2.7l1.1,0.5c3.8,1.6,6,3.3,6,7.1c0,4.1-3.2,6.3-7.5,6.3C32.6,44.2,29.9,42.2,28.6,39.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.96340bdc966ad19d27356044f30d0345.svg";
export { ForwardRef as ReactComponent };